import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex space-x-4" }
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_6 = { class: "mb-1 font-semibold" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mb-1 font-semibold" }
const _hoisted_9 = { controls: "" }
const _hoisted_10 = ["src", "type"]

import { ref, onMounted } from 'vue';
import { useRoute, RouterLink } from 'vue-router';

import { useUiStore } from '@/stores';
import ConnectFlowAudioService from '@/services/api/ConnectFlowAudioService';
import VaultService from '@/services/api/VaultService';
import { toastServiceError } from '@/services/core/notification';

import { ConnectFlowAudioModel, Permission } from '@/types';
import { getAudioFormat } from '@/utils/audio';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowAudioDetailPage',
  setup(__props) {

const route = useRoute();
const uiStore = useUiStore();

const connectFlowAudio = ref<ConnectFlowAudioModel | undefined>(undefined);
const audioData = ref();

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const fetchConnectFlowAudio = async (id: number) => {
    await setLoading(true);
    try {
        const { data } = await ConnectFlowAudioService.get<ConnectFlowAudioModel>(id);
        connectFlowAudio.value = data;

        const { data: audioAsset } = await VaultService.getAudioAsset(
            connectFlowAudio.value.audioFilePath,
        );

        audioData.value = URL.createObjectURL(
            new Blob([audioAsset], {
                type: getAudioFormat(connectFlowAudio.value?.audioFilePath),
            }),
        );
    } catch (error) {
        toastServiceError(error);
    } finally {
        await setLoading(false);
    }
};

onMounted(() => {
    const id = Number(route.params.id);
    fetchConnectFlowAudio(id);
});

return (_ctx: any,_cache: any) => {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiAuditStatusInfo = _resolveComponent("UiAuditStatusInfo")!
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('connectFlowAudio.view.title')), 1)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListConnectFlowAudio' } }),
          (_ctx.$can(_unref(Permission).EDIT_CONNECT_FLOW_AUDIO))
            ? (_openBlock(), _createBlock(_unref(RouterLink), {
                key: 0,
                to: { name: 'EditConnectFlowAudioById', params: { id: _unref(route).params.id } },
                class: "block hover:bg-gray-50"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "primary",
                    "text-variant": "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Edit')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_UiPanel, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('connectFlowAudio.labels.name')), 1),
              _createElementVNode("p", null, _toDisplayString(connectFlowAudio.value?.name), 1)
            ]),
            (audioData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('connectFlowAudio.labels.file')), 1),
                  _createElementVNode("audio", _hoisted_9, [
                    _createElementVNode("source", {
                      src: audioData.value,
                      type: _unref(getAudioFormat)(connectFlowAudio.value?.audioFilePath || '')
                    }, null, 8, _hoisted_10),
                    _cache[0] || (_cache[0] = _createTextVNode(" Your browser does not support the audio element. ", -1))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_UiAuditStatusInfo, {
            "model-value": connectFlowAudio.value,
            class: "bt-1 mt-4 border-t border-gray-300 pt-2"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})